<template>
  <v-container>


    <v-main class="container mainContainer" v-bind:class="{ is_devices_page: is_devices_page }">


      <v-row class="wrap_main_row">


        <v-col md="3" class="pre_cart " v-if="!is_devices_page">
          <side-bar
              :algorithm_list="algorithm_list"
              :product_id="product_id"
              :qty="qty"
              :setDLL="setDLL"
              :dll="dll"
              :secure_programming="secure_programming"
              :items="items"
              :setDynamicSelectedProductID="setDynamicSelectedProductID"
              :dynamicSelectedProductID="dynamicSelectedProductID"
              :pricing="pricing"
              :dynamicSelectedProductIDPrice="dynamicSelectedProductIDPrice"
              :selectedItem="selectedItem"
              :devices_rows="devices_rows"
          ></side-bar>
        </v-col>

        <v-col md="9" class="">
          <v-form v-model="valid">
            <v-container class="">


              <AdminUserDropDown
                  v-if="!is_devices_page"
                  :usersList="usersList"
                  :currentUserSelected="currentUserSelected"
                  :setPrecartProduct="setPrecartProduct"
                  :setCurrentUser="setCurrentUser"
                  :isAdmin="isAdmin"
              ></AdminUserDropDown>


              <v-stepper
                  v-model="e6"
                  vertical
              >
                <v-stepper-step
                    v-if="!is_devices_page"
                    @click="e6 = 1"
                    :complete="e6 > 1"
                    step="1"
                >
                  <div v-if="!is_devices_page">Please select a product</div>
                  <small></small>
                </v-stepper-step>

                <v-stepper-content step="1" v-if="!is_devices_page">


                  <div v-if="showProductsList">
                    <ProductsList
                        :setProductID="setProductID"
                        :items="items"
                        :product_id="product_id"
                        :is_user_logged_in="is_user_logged_in"
                        :setPrecartProduct="setPrecartProduct"
                        :setStep2="setStep2"
                    >
                    </ProductsList>
                  </div>


                </v-stepper-content>

                <v-stepper-step
                    v-if="!is_devices_page"
                    @click="setStep2"
                    :complete="e6 > 2"
                    step="2"
                >
                  Please select a device

                </v-stepper-step>

                <v-stepper-content step="2">

                  <AddDevices
                      :devices_rows="devices_rows"
                      :remove_row="remove_row"
                      :is_user_logged_in="is_user_logged_in"
                      :device_list="device_list"
                      :algorithm_list="algorithm_list"
                      :support_time="support_time"
                      :secure_programming="secure_programming"
                      :dll="dll"
                      :setDLL="setDLL"
                      :setSecureProgramming="setSecureProgramming"
                      :openDeviceList="openDeviceList"
                      :add_row="add_row"
                      :openAllRowsDevicesList="openAllRowsDevicesList"
                      :is_devices_page="is_devices_page"
                      :change_row="change_row"
                      :setNotSupportedDeviceFound="setNotSupportedDeviceFound"
                      :notSupportedDeviceFound="notSupportedDeviceFound"
                      :currentUserSelected="currentUserSelected"
                      :text="text"
                      :setSnackbar="setSnackbar"
                      :setText="setText"
                  >

                  </AddDevices>

                  <div v-if="devices_rows.length">
                    <div v-if="devices_rows[0].device_id" class="text-center">
                      <v-btn
                          v-if="is_devices_page && hide_for_now"
                          color="green"
                          class="ma-2 white--text"
                          @click="goToOrderApp()"
                      >
                        CONVERT TO ORDER

                      </v-btn>
                    </div>
                  </div>
                  <v-btn
                      v-if="devices_rows[(devices_rows.length) - 1].device_id && !notSupportedDeviceFound && !is_devices_page"
                      color="primary"
                      @click="e6 = 3"
                  >
                    Continue
                  </v-btn>

                </v-stepper-content>

                <v-stepper-step
                    v-if="!is_devices_page"
                    @click="setStep3"
                    :complete="e6 > 3"
                    step="3"
                >
                  <div v-if="!is_devices_page">Please select options</div>
                </v-stepper-step>

                <v-stepper-content step="3" v-if="!is_devices_page">


                  <AddOptions
                      :is_devices_page="is_devices_page"
                      :dll="dll"
                      :setDLL="setDLL"
                      :change_row="change_row"
                      :secure_programming="secure_programming"
                      :setSecureProgramming="setSecureProgramming"
                  >
                  </AddOptions>


                  <v-btn
                      v-if="devices_rows[0].device_id && !notSupportedDeviceFound"
                      color="primary"
                      @click="e6 = 4"
                  >
                    Continue
                  </v-btn>

                </v-stepper-content>

                <v-stepper-step step="4" v-if="!is_devices_page">

                  Add To Cart
                </v-stepper-step>
                <v-stepper-content step="4" v-if="!is_devices_page">


                  <div v-if="showalgorithm">


                    <div v-if="devices_rows.length && !notSupportedDeviceFound">
                      <div v-if="devices_rows[0].device_id">




                        <input name="qty" id="qty"

                            v-if="!is_devices_page"
                            @change="change_row()"
                            v-model="qty"
                            label="QTY"
                            type="number"
                               min="1"
max="9999"
                                 />





                        <v-btn color="green lighten-2" dark v-bind="attrs"
                               v-if="!is_devices_page"
                               @click="addToCart"
                               :disable="savingOrder"
                               v-on="on">
                          {{ !savingOrder ? 'Add To Cart' : 'Saving ...' }}
                        </v-btn>


                      </div>
                    </div>

                  </div>


                </v-stepper-content>
              </v-stepper>


              <v-row v-if="currentUserSelected && isAdmin">
                <v-flex>
                  <div class="text-center">
                    <v-btn

                        :disable="sendingEmail"
                        color="error"
                        class="green text-center mt-10 ma-2 white--text"
                        @click="emailPrecardToUser()"
                    >
                      <v-progress-circular
                          v-if="sendingEmail"
                          indeterminate
                          color="primary"
                      ></v-progress-circular>


                      <v-icon

                          color="white "
                      >
                        mdi-email
                      </v-icon>
                      EMAIL THIS PREORDER TO THE SELECTED USER
                    </v-btn>
                  </div>
                </v-flex>
              </v-row>


              <div class="text-center">
                <v-dialog v-model="dialog" width="600">

                  <v-card>
                    <v-card-title class="headline grey lighten-2">Devices List
                      Support
                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-card-title>

                    <v-card-text>

                      <v-data-table
                          :headers="dialogHeaders"
                          :items="dialogDevaicesList"
                          :items-per-page="20"
                          :search="search"
                          class="elevation-1"
                      ></v-data-table>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>


                      <v-btn color="primary" text
                             @click="exportJSONToCSV(dialogDevaicesList)">export
                        to csv
                      </v-btn>
                      <v-btn color="primary" text @click="dialog = false">CLOSE
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>


            </v-container>
          </v-form>
        </v-col>
      </v-row>


      <div class="text-center ma-2">
        <v-snackbar
            v-model="snackbar"
        >
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn
                color="pink"
                text
                v-bind="attrs"
                @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>

    </v-main>
  </v-container>
</template>

<script>
import Api from '../api.js';
//  import storeAPI from '../storeAPI.js';
import SideBar from './SideBar';
import AdminUserDropDown from './AdminUserDropDown';
import ProductsList from './ProductsList';
import AddDevices from "./AddDevices";
import AddOptions from './AddOptions';

export default {
  name: "OrderApp",

  components: {
    AddDevices,
    AddOptions,
    SideBar: SideBar,
    AdminUserDropDown: AdminUserDropDown,
    ProductsList: ProductsList
  },
  data: () => ({
    e6: 1,
    product_id: 0,
    dynamicSelectedProductID: "",
    algorithms_selected: [],
    snackbar: false,
    text: `Product Added to cart successfully!. Page is Reloading ..`,
    dialog: false,
    valid: false,
    firstname: "",
    lastname: "",
    devices: "",
    is_user_logged_in: 0,
    devices_rows: [{id: 2}],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => v.length <= 10 || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    qty: 1,
    items: [],
    device_list: [],
    first_device_list: "",
    pricing: [],
    algorithm_list: [],
    vendors: [],
    support_time: [],
    is_loading: false,
    listUsersPreCarts: [],
    currentUserSelected: 0,
    is_devices_page: false,
    isAdmin: 0,
    dll: false,
    secure_programming: false,
    dialogHeaders: [
      {text: 'Device ID', value: 'id'},
      {text: 'Description', value: 'device_description'},
    ],
    dialogDevaicesList: [],
    search: '',
    price: 0,
    nonce: '',
    links: [],
    savingOrder: false,
    notSupportedDeviceFound: false,
    steps: [{step: 1, title: 'Step 1', isActive: true}, {step: 2, title: 'Step 2', isActive: false}, {
      step: 3,
      title: 'Step 3',
      isActive: false
    }]
  }),
  mounted() {
    this.items = window.order_app_data.products;
    this.device_list = window.order_app_data.devices;
    this.pricing = window.order_app_data.pricing;
    this.algorithm_list = window.order_app_data.algorithms;
    this.vendors = window.order_app_data.vendors;
    this.support_time = window.order_app_data.support_time;
    this.is_user_logged_in = parseInt(window.order_app_data.is_user_logged_in);
    this.currentUserSelected = this.is_user_logged_in;
    this.is_devices_page = parseInt(window.order_app_data.is_devices_page);
if(this.is_devices_page){
  this.device_list.shift();


}


    this.setDevicesPage();
    this.isAdmin = parseInt(window.order_app_data.is_admin);
    if (!this.is_devices_page) {
      this.getListUsersPreCarts();
      this.productFromLink();
      this.userFromLink();
    }
    this.nonce = window.order_app_data.nonce;

  }, watch: {



    product_id(newValue) {
      if (newValue) {



        /* this.$nextTick(() => {
             this.$vuetify.goTo('.firstContinueBtn', {
                 duration: 1000,
                 offset: 120,
             });
         });
*/
        //  this.e6 = 2;
      }
      /*
     this.steps.map(step => {



         if(newValue && step.step == 2 ){
             step.isActive = true;

         }else if(!newValue  && step.step == 1){
             step.isActive = true;
         }else{
             step.isActive = false;

         }
         return step;
     })
     */
    }
  },
  filters: {
    formatCurrency: function (value) {
      if (!value) return ''
      return `$${value.toFixed(2)}`;
    }
  },
  computed: {
    dynamicSelectedProductIDPrice() {
      if (this.product_id == '' || !this.selectedItem) {
        return '';
      }
      if (!this.selectedItem.price) {
        return '';
      }
      let dsPrice = 0;
      let qtyPrice = 0;
      let returnPrice = 0;

      let selectedProductPrice = this.selectedItem.price;

      let dynamicSelectedProductIDString = this.selectedItem.name;

      if (this.dll && !this.secure_programming) {
        dynamicSelectedProductIDString = dynamicSelectedProductIDString + '-';
        dynamicSelectedProductIDString = dynamicSelectedProductIDString + 'DLL';
      } else if (this.dll && this.secure_programming) {
        dynamicSelectedProductIDString = dynamicSelectedProductIDString + '-';
        dynamicSelectedProductIDString = dynamicSelectedProductIDString + 'DS';
      }
      if (this.dll || this.secure_programming) {
        dsPrice = this.pricing.find(price => {
          return price.id == dynamicSelectedProductIDString;
        });
      }


      let devices_rows_count = 0;
      //devices_rows_count--;

      let ar_listAlgorithmsRows = [];


      let algorithm_list = this.algorithm_list;

      this.devices_rows.map(devices_row => {

        if (typeof devices_row.device_id === 'object' && devices_row.device_id !== null) {


          //   console.log('devices_rows2.algorithm= --' + devices_row.device_id.algorithm);


          let algorithm_payable = algorithm_list[devices_row.device_id.algorithm];
          // console.log(algorithm_payable.id);
          //console.log(algorithm_payable.algorithm_payable);

          if (algorithm_payable.algorithm_payable == '1' && !ar_listAlgorithmsRows.includes(devices_row.device_id.algorithm)) {
            ar_listAlgorithmsRows.push(devices_row.device_id.algorithm);
            console.log('---');
            console.log(ar_listAlgorithmsRows);
            devices_rows_count++;
          }


        }

      });

      /*
      this.devices_rows.map(algoritm => {
          if (algoritm.algorithm_payable && !ar_listAlgorithmsRows.includes(algoritm.device_id.algorithm)) {
              ar_listAlgorithmsRows.push(algoritm.device_id.algorithm);
              devices_rows_count++;
          }
      });
*/
      if (devices_rows_count) {
        qtyPrice = this.pricing.find(price => {
          return price.id == this.selectedItem.name + '-' + 'FAM' + devices_rows_count;
        });
      }


      returnPrice = (selectedProductPrice * 1);
      if (dsPrice) {
        returnPrice = returnPrice + (dsPrice.price * 1);
      }
      if (qtyPrice) {
        returnPrice = returnPrice + (qtyPrice.price * 1);
      }
      return "$" + returnPrice.toFixed(2);

    },
    selectedItem() {
      if (this.product_id == '') {
        return '';
      }



       return this.items.find(item => {
         if(item.product_id == this.product_id){
           if(item.category == 'Hardware' && this.device_list[0]['id'] == '_NO_DEVICE_REQUIRED'){
             if(!this.first_device_list) {
               this.first_device_list = this.device_list[0];
               this.device_list.shift();
             }



           }else{
             if(item.category !== 'Hardware' && this.device_list[0]['id'] !== '_NO_DEVICE_REQUIRED'){
               if(this.first_device_list){
                 this.device_list.unshift(this.first_device_list);
                 this.first_device_list = "";
               }
             }
           }
           return item.product_id;
         }
      });





    },
    showProductsList() {
      if (this.is_devices_page) {
        return false;
      }
      return 1;

      //return (this.usersList.length > 0 && this.currentUserSelected) || this.usersList.length === 1 || !this.is_user_logged_in
    },
    showalgorithm() {
      if (this.is_devices_page) {
        return true;
      }
      return this.product_id > 0

    },
    qtyArray() {
      return [...Array(255).keys()].map(x => x + 1);
    },
    usersList() {
      if (this.listUsersPreCarts.length > 0) {

        let ar_listUsersPreCarts = this.listUsersPreCarts.map(user => {
          return {
            id: user.user_data.ID,
            name: `${user.user_data.firstName} ${user.user_data.lastName} ${user.user_data.user_email}`,
          };
        });
        // ar_listUsersPreCarts.unshift({id:0,name:""});
        return ar_listUsersPreCarts;
      } else {
        return [];
      }
    }
  },
  methods: {
    setDevicesPage() {
      if (this.is_devices_page) {
        setTimeout(() => {
          this.e6 = 2
        }, 1);
      }
    },

    emailPrecardToUser() {
      this.sendingEmail = true
      this.setSnackbar(false);
      this.setText(`Email sent!`);
      Api.post('/order-app/email-precart-to-user', {
        "user": this.currentUserSelected,
      })

          .then(() => {
            this.sendingEmail = false;
            this.setSnackbar(true);
            // always executed
          });

    }, setStep2() {
      if (this.product_id) {// && !this.notSupportedDeviceFound
        if (!this.is_user_logged_in) {
          window.jQuery('.sw-open-login').click();
          return;
        }

        this.e6 = 2
        this.$nextTick(() => {
          this.$vuetify.goTo('.mainContainer', {
            duration: 1000,
            offset: 120,
          });
        });
      }
    }, setStep3() {
      if (this.product_id && this.devices_rows[0].device_id && !this.notSupportedDeviceFound) {
        this.e6 = 3
      }
    },
    setSnackbar(value) {
      this.snackbar = value;
    },
    setText(value) {
      this.text = value;
    },
    setNotSupportedDeviceFound(value) {
      this.notSupportedDeviceFound = value;
    },
    getLinks: function () {
      this.links = this.$store.state.links;
    },
    activateLink: function (index) {
      // this.$store.dispatch('activateLink', { index });
      this.$store.commit('activateLink', {index});
    },
    goToOrderApp() {
      location.href = '/order-now/';
    },
    exportJSONToCSV(objArray) {
      var arr = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
      var str = "Part Number,Vendor,Family,Support Time,Device Description";
     // console.log(arr);
     // console.log('----------');

      var csvContent = arr.map((dialogDevaicesList_row) => {
        let strVendor = this.vendors[dialogDevaicesList_row.vendor];
        let strSupportTime = this.support_time[dialogDevaicesList_row.support_time];
        let strAlgorithm = this.algorithm_list[dialogDevaicesList_row.algorithm];


        let strID = dialogDevaicesList_row.id;
        //  console.log(dialogDevaicesList_row.algorithm);
        // console.log('----------');
        // console.log(this.algorithm_list[dialogDevaicesList_row.algorithm]);
        return '\r\n"' + [strID, strVendor.vendor_name, strAlgorithm.algorithm_description, strSupportTime.message, dialogDevaicesList_row.device_description].join('","') + '"';
      });

      var element = document.createElement('a');
      element.href = 'data:text/csv;charset=utf-8,' + encodeURI(str + csvContent);
      element.target = '_blank';
      element.download = 'export.csv';
      element.click();
    },
    openDeviceList(algoritmID) {
      let vm = this.device_list;

      // this.dialogDevaicesList = vm.filter(device => {
      //     return device.algorithm == algoritmID
      //});
      // this.dialogDevaicesList = this.device_list.filter(device => ar_listAlgorithmsRows.includes(device.algorithm));

      this.dialogDevaicesList = vm.filter(device => {
        return device.algorithm == algoritmID
      });

      this.dialog = true
    },
    openAllRowsDevicesList() {
      let ar_listAlgorithmsRows = [];

      //get algoritms from devices rows
      this.devices_rows.map(algoritm => {
        if (!ar_listAlgorithmsRows.includes(algoritm.device_id.algorithm)) {
          ar_listAlgorithmsRows.push(algoritm.device_id.algorithm);
        }
      });
      // console.log(ar_listAlgorithmsRows);

      this.dialogDevaicesList = this.device_list.filter(device => ar_listAlgorithmsRows.includes(device.algorithm));

      this.dialog = true
    },
    setDynamicSelectedProductID(value) {
      this.dynamicSelectedProductID = value
    },
    setCurrentUser(userID) {
      this.currentUserSelected = userID
    },
    setProductID(productID) {
      // productID = productID.replace(/^\s+|\s+$|^\t+|\t+$/g, "");
      this.product_id = productID
    },
    setDLL(value) {
      this.dll = value
    },
    setSecureProgramming(value) {
      this.secure_programming = value
    },
    getCurrentData() {



      let ar_listAlgorithmsRows = [];

      //get algoritms from devices rows
      this.devices_rows.map(algoritm => {
        if (!ar_listAlgorithmsRows.includes(algoritm.device_id.algorithm)) {
          ar_listAlgorithmsRows.push(algoritm.device_id.algorithm);
        }
      });

      this.algorithms_selected = ar_listAlgorithmsRows;

      return {
        product_id: this.product_id,
        devices_rows: this.devices_rows,
        qty: this.qty,
        dll: this.dll,
        secure_programming: this.secure_programming,
        dynamicSelectedProductID: this.dynamicSelectedProductID,
        algorithms_selected: this.algorithms_selected,
        user: this.currentUserSelected,
        custom_price: this.dynamicSelectedProductIDPrice,
      }
    },

    addToCart() {

//if(this.qty <= 0){
 // alert('Min Qty is required');
//}
      let data = this.getCurrentData();
      this.savingOrder = true;

      Api.post('/order-app/add-to-cart', data)
          .then(response => {
            this.snackbar = 1;
            this.savingOrder = false;

            setTimeout(function () {
              location.reload();
            }, 1000);

            // location.reload();
            console.log(response);
          })
          .catch(error => {
            this.snackbar = 1;
            this.savingOrder = false;
            this.snackbar.message = `Add to cart Error!`,
                console.log(error);
          })
          .then(() => {
            this.is_loading = false;
            this.savingOrder = false;
            // always executed
          });

    },
    createUser() {
      const self = this;
      this.is_loading = true;
      // Optionally the request above could also be done as
      Api.post('/wp/v2/users', {
        username: this.firstname,
        email: this.email,
        password: 'placeholder',

      })
          .then(function (response) {
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            self.is_loading = false;
            // always executed
          });
    },
    signUp() {

    },
    submit() {
      console.log(this.email);
    },
    getListUsersPreCarts() {
      if (!this.is_user_logged_in) {
        return;
      }

      Api.get('/order-app/list-users-pre-carts')
          .then(response => {
            if (response.data !== 'no users found') {
              this.listUsersPreCarts = response.data;
              this.setPrecartProduct();


              console.log(this.listUsersPreCarts);
            }
          })
          .catch(error => {
            console.log(error);
          })
          .then(() => {
            this.is_loading = false;
          });
    }
    ,
    change_row(device_id = "") {

      let str_device_id = "";
       if(device_id.id) {
         str_device_id = device_id.id;
       }else {
         str_device_id = device_id;
       }
      Api.post('/order-app/save-device-log', {
        "page": this.is_devices_page ? 'devices' : 'order',
        "product_id":this.product_id,
        "device":str_device_id,
        "algorithm":device_id.algorithm,
      })
          .then(response => {
            this.info = response.data;
            console.log(response.data.PhoneBook);
          })
          .catch(error => {
            console.log(error);
          })
          .then(() => {
             // always executed
          });

      if (this.is_devices_page) {
        return;
      }

      let data = this.getCurrentData();

      Api.post('/order-app/save-pre-cart', data)
          .then(response => {
            console.log(response);
          })
          .catch(error => {
            console.log(error);
          })
          .then(() => {
            this.is_loading = false;
            // always executed
          });


    }, add_row() {

      this.devices_rows.push({id: "2"});
    }
    , remove_row(index) {
      this.devices_rows.splice(index, 1);
      this.change_row();
      console.log(index);
    },

    setPrecartProduct() {
      this.logedUserPrepareDeviceLines();
    },
    logedUserPrepareDeviceLines() {
      if (!this.isAdmin && this.listUsersPreCarts[0].pre_cart) {//!this.currentUserSelected &&
        if (!this.currentUserSelected) {
          this.currentUserSelected = this.is_user_logged_in;
        }
        if (this.listUsersPreCarts[0].pre_cart.devices_rows) {
          this.devices_rows = this.listUsersPreCarts[0].pre_cart.devices_rows;

          /*
                                 this.setNotSupportedDeviceFound(false);
                                 this.devices_rows.forEach(device => {
                                     //console.log(device);
                                     // console.log(this.flatDevicesList);
                                     //console.log(!this.flatDevicesList.includes(device.device_id.id));
                                     if (!this.flatDevicesList.includes(device.device_id.id)) {
                                         this.setNotSupportedDeviceFound(true);
                                     }
                                 })
          */
        }


        if (this.listUsersPreCarts[0].pre_cart.product_id) {
          this.product_id = this.listUsersPreCarts[0].pre_cart.product_id;
        }
        this.qty = this.listUsersPreCarts[0].pre_cart.qty;
        this.dll = this.listUsersPreCarts[0].pre_cart.dll;
        this.secure_programming = this.listUsersPreCarts[0].pre_cart.secure_programming;
      }
      // console.log(this.currentUserSelected + "-" + this.is_user_logged_in);

      if (this.currentUserSelected) {

        let selectedUserID = this.currentUserSelected;
        let selectedUserProducts = this.listUsersPreCarts.find(user => {
          let wpUserID = parseInt(user.user_data.ID);
          return wpUserID == selectedUserID
        });
        // console.log(selectedUserProducts);
        if (selectedUserProducts) {

          //let supportedAlgorithmList = [];
//get supported algorithms


          //filter by device
          //
          console.log(this.devices_rows);
          console.log('+++++++++++');

          let supported_devices = selectedUserProducts.pre_cart.devices_rows.flatMap(devices_row => {

            //// if (!this.algorithm_list[devices_row.device_id.algorithm].algorithm_description !== 'Not supported') {
            ////console.log(devices_row);
            return [devices_row];
            //// }
            ////  return [];

          });
          this.devices_rows = [];

          this.devices_rows = supported_devices;
          // this.devices_rows = selectedUserProducts.pre_cart.devices_rows;
          this.product_id = selectedUserProducts.pre_cart.product_id;
          this.qty = selectedUserProducts.pre_cart.qty;
          this.dll = selectedUserProducts.pre_cart.dll;
          this.secure_programming = selectedUserProducts.pre_cart.secure_programming;
          /*this.devices_rows.map(devices_row =>  {
              if(typeof devices_row.device_id === 'object' && devices_row.device_id !== null ){
                  devices_row.supported = true;
              }else{
                  devices_row.supported = false;

              }
              return devices_row;
          })*/
          /*selectedUserProducts.pre_cart.map((row, index) => {
              this.device_id[index] = row;


          })*/
        }
      }

      //// if (this.devices_rows.length && !this.product_id) {
      ////    let firstItem = this.items.filter(item => item.category == 'Hardware');
      ////    this.product_id = firstItem[0].product_id;
      ////}
    }
    ,
    productFromLink() {
      let urlParams = new URLSearchParams(window.location.search);
      let addProduct = urlParams.get('add');

      if (addProduct) {
        this.product_id = parseInt(addProduct);
      }
    },
    userFromLink() {
      let urlParams = new URLSearchParams(window.location.search);
      let selectUser = urlParams.get('user');

      if (selectUser) {
        this.currentUserSelected = selectUser;
      }


    }
  },
};
</script>

<style>
#qty {
  margin-right: 20px;
  width: 45px;
}
span.returnSupported_text {
  font-weight: 700;
}

span.returnSupported_text_red {
  font-weight: 700;
  color: #AD2E14;
}

.v-avatar
body .v-application .primary {
  background-color: #AD2E14 !important;
  border-color: #AD2E14 !important;
}

div#wrapUpgrade {
  padding-top: 65px;
}

#app h3 {
  padding-top: 0 !important;
  font-size: 35px !important;
}

.v-alert {
  min-height: 54px;
}

a.v-btn.v-btn--text.theme--light.v-size--default {
  display: none;
}

header.page-header {
  display: none;
}

main.site-main {
  padding-top: 30px;
}

.is_devices_page .v-stepper--vertical .v-stepper__content {
  padding: 30px 60px 0px 0px !important;
  width: auto;
}

.v-stepper__wrapper {
  padding-left: 13px;
}

@media (max-width: 1000px) {
  .v-input--selection-controls__input {
    position: initial !important;
  }

  div#wrapHardware .v-image, div#wrapUpgrade .v-image {
    max-width: 100% !important;
  }

  #wrapHardware .v-input--selection-controls__input {
    position: relative !important;
  }

  #wrapUpgrade .v-input--selection-controls__input {
    position: relative !important;
  }


  .row.wrap_main_row {
    flex-direction: column-reverse;
  }

  body .pre_cart_info.mx-auto.p-5.v-card.v-sheet.v-sheet--outlined.theme--light {
    position: relative !important;
  }

  #app {
    padding: 0px !important;
  }

  #app h3 {
    /* padding-top: 65px; */
    font-size: 24px !important;
  }

  .row {

    margin: 0 !important;
  }

  hr.v-divider.theme--light {
    margin: 27px !important;
  }

  .v-input--selection-controls__input {
    left: calc(50% - 12px) !important;
    padding-bottom: 43px !important;
    padding-top: 20px !important;
  }

  .pre_cart_info.mx-auto.p-5.v-card.v-sheet.v-sheet--outlined.theme--light {
    top: 0 !important;
  }

  .container {
    padding: 0 !IMPORTANT;
  }

  .v-application--is-ltr .v-stepper--vertical .v-stepper__content {
    margin: 0 -0 0 36px;
  }
}

</style>